import Mutations from '../../odata/mutations';

export default { ...new Mutations('receivingOfCultivatedAbolone'), ...new Mutations('receivingOfCultivatedAbolones') };
